import noticeCenter from '../../views/notice-model/notice-center.vue';
import noticeAssistant from '../../views/notice-model/notice-assistant.vue';
var noticeRouter = [
    {
        name: 'noticeCenter',
        path: 'notice-center',
        component: noticeCenter,
    },
    {
        name: 'noticeAssistant',
        path: 'notice-assistant',
        component: noticeAssistant,
    },
];
export default noticeRouter;
